import React from 'react';
import { Link } from 'gatsby';
import Img from "gatsby-image"
import { Container } from './postpage.css';

export default function PostPage({ post }) {
  if (post == undefined || post == null) {
    return (
      <Container>
        <div className="category-wrapper"></div>
        <div className="content-wrapper"></div>
        </Container>
    );
  }
  else {
    return (
      <Container className="post-page-wrapper">
        <h3>by {post.frontmatter.author} on {post.frontmatter.date}</h3>
        <div className="category-wrapper">
          <span className="cat">
            <Link to={post.frontmatter.slug}>{post.frontmatter.categories}</Link>
          </span>
        </div>
        <div className="content-wrapper">
            <div className="img-wrapper">
              <Img
                fluid={post.frontmatter.image ? post.frontmatter.image.childImageSharp.fluid : {}}
                alt={post.frontmatter.title}
              />
            </div>
            <div className="post-wrapper" dangerouslySetInnerHTML={{ __html: post.html }} />
        </div>
      </Container>
    );
  }
}
